import { Editor, EditorProps, OnMount } from "@monaco-editor/react";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Switch,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import type * as monaco from "monaco-editor";
import {
  clientesEContratosHtml,
  diretoriaHtml,
  ocorrenciasHtml,
} from "./defaultsHtml";
import { Stack } from "@mui/system";

interface MyEditorProps extends EditorProps {
  stringHtml: string;
  defaultCard: string;
  handleChangeGraph: (key: string, value: string) => void;
}

const HtmlEditor: React.FC<MyEditorProps> = ({
  stringHtml,
  defaultCard,
  handleChangeGraph,
}) => {
  const theme = useTheme();
  const editorRef = useRef<monaco.editor.IStandaloneCodeEditor>();
  const [selectedHtml, setSelectedHtml] = useState<string>("");
  const [checked, setChecked] = useState<boolean>(false);
  const handleMount: OnMount = (editor, monacoInstance) => {
    editorRef.current = editor;
    editor.getAction("editor.action.formatDocument")?.run();
    editor.layout();
  };

  useEffect(() => {
    if (defaultCard) {
      setChecked(true);
    }
  }, [defaultCard]);
  const defaultsHtml = [
    { html: diretoriaHtml, key: "diretoria" },
    { html: clientesEContratosHtml, key: "clientesEContratos" },
    { html: ocorrenciasHtml, key: "ocorrencias" },
  ];
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: 2,
        }}
      >
        <Divider />
        <FormControl>
          <FormLabel
            sx={{
              color: theme.palette.text.primary,
              "&.Mui-focused": {
                color: theme.palette.text.primary,
              },
            }}
          >
            Habilitar Cartões
          </FormLabel>
          <FormControlLabel
            value="bottom"
            control={
              <Switch
                sx={{
                  marginLeft: -1,
                }}
                checked={checked}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setChecked(isChecked);
                  if (!isChecked) {
                    handleChangeGraph("defaultCard", "");
                  }
                }}
              />
            }
            label="Escolhe html default"
            labelPlacement="top"
            sx={{
              color: theme.palette.text.secondary,
              alignItems: "start",
              marginLeft: 0,
              "& .MuiFormControlLabel-label": {
                fontSize: "14px",
              },
            }}
          />
        </FormControl>
        {checked && (
          <>
            <Grid container columnSpacing={1.5} rowSpacing={2}>
              {defaultsHtml.map(({ html, key }) => (
                <Grid size={{ xs: 12, sm: 12, lg: 6, xl: 4 }}>
                  <Box
                    sx={{
                      cursor: "pointer",
                      padding: key === "diretoria" ? 0.3 : 0,
                      width: "100%",
                      height: "140px",
                      borderRadius: 2,
                      border:
                        selectedHtml === html || defaultCard === key
                          ? `1px solid ${theme.palette.primary.main}`
                          : `1px solid ${theme.palette.stroke}`,
                      backgroundColor: "background.paper",
                    }}
                    onClick={() => {
                      setSelectedHtml(html);
                      handleChangeGraph("defaultCard", key);
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "12px",
                      }}
                      dangerouslySetInnerHTML={{ __html: html }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Box>
      <Box height={600}>
        <Editor
          key="monaco-editors"
          defaultLanguage="html"
          height="100%"
          defaultValue={stringHtml}
          value={selectedHtml ? selectedHtml : stringHtml}
          onChange={(v) => handleChangeGraph("html", v ?? "")}
          theme={theme.palette.mode === "dark" ? "vs-dark" : "light"}
          options={{
            minimap: { enabled: false },
            formatOnPaste: true,
            formatOnType: true,
            scrollBeyondLastLine: false,
            automaticLayout: false,
          }}
          onMount={handleMount}
        />
      </Box>
    </Box>
  );
};
export default HtmlEditor;
